module.exports = __webpack_public_path__ + "img/filter.c3d027d8.svg";